@if (visible()) {
  <div class="version-popup">Version: {{ version() || 'n/a' }}</div>
}
